import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";
import HomeDataCardTracked from "../../containers/HomeDataCard/HomeDataCardTracked";
import type { HomeDataCardProps } from "../common/HomeDataCard/HomeDataCard";

const CARD_ID = "lists";

type Props = Pick<HomeDataCardProps, "headerContent" | "children"> & {
    metadata: ViewModelMetadata;
};

const ListsCard = ({ headerContent, children, metadata }: Props) => {
    return (
        <HomeDataCardTracked
            automationId={CARD_ID}
            title={{ key: `si.pages.home.card.${CARD_ID}.title` }}
            iconName="purple-triple-list-outline"
            headerContent={headerContent}
            metadata={metadata}
        >
            {children}
        </HomeDataCardTracked>
    );
};

export default ListsCard;
